import { ProductCard, type ProductListing } from '@entities/product';
import styles from './ProductGrid.module.css';

/** Cap entrance delay so a long catalog remains quick to browse. */
const STAGGER_CAP = 8;
const ABOVE_FOLD = 6;

interface ProductGridProps {
  products: ProductListing[];
  onSelect: (listing: ProductListing) => void;
  onBuy: (listing: ProductListing) => void;
  clockOffsetMs?: number;
}

export function ProductGrid({ products, onSelect, onBuy, clockOffsetMs = 0 }: ProductGridProps) {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {products.map((listing, index) => (
          <div
            key={listing.key}
            id={`product-${listing.primary.id}`}
            className={styles.item}
            style={{ animationDelay: `${Math.min(index, STAGGER_CAP) * 0.03}s` }}
          >
            <ProductCard
              listing={listing}
              onSelect={onSelect}
              onBuy={onBuy}
              eager={index < ABOVE_FOLD}
              clockOffsetMs={clockOffsetMs}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
